import { useState, useEffect } from 'react'
import { Clock, ChevronDown } from 'lucide-react'
import { setTimezone as setApiTimezone } from '../api/client'

const TIMEZONES = [
  'UTC', 'Europe/Berlin', 'Europe/London', 'America/New_York',
  'America/Los_Angeles', 'Asia/Tokyo', 'Asia/Singapore', 'Australia/Sydney',
]

export function TimezoneSelector() {
  const [timezone, setTimezone] = useState(() => localStorage.getItem('timezone') || 'UTC')
  const [currentTime, setCurrentTime] = useState('')
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    setApiTimezone(timezone)
    localStorage.setItem('timezone', timezone)
  }, [timezone])

  useEffect(() => {
    const updateTime = () => {
      try {
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: timezone, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
        })
        setCurrentTime(formatter.format(new Date()))
      } catch { setCurrentTime('--:--:--') }
    }
    updateTime()
    const interval = setInterval(updateTime, 1000)
    return () => clearInterval(interval)
  }, [timezone])

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2 text-foreground">
        <Clock className="h-5 w-5" />
        <span className="font-mono text-sm font-semibold">{currentTime}</span>
      </div>
      <div className="relative">
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="flex items-center gap-2 rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
        >
          {timezone}
          <ChevronDown className="h-4 w-4" />
        </button>
        {showDropdown && (
          <div className="absolute right-0 top-full z-50 mt-2 w-48 rounded-lg border border-border bg-popover shadow-lg">
            {TIMEZONES.map((tz) => (
              <button
                key={tz}
                onClick={() => { setTimezone(tz); setShowDropdown(false) }}
                className={`block w-full px-4 py-2 text-left text-sm transition-colors ${
                  timezone === tz ? 'bg-accent text-white' : 'text-foreground hover:bg-muted'
                }`}
              >
                {tz}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
